import modulesReducer from "./actionsReduces";

export const modulesReducerObject = {
  modules: modulesReducer,
};
